import { useEffect } from "react";
import StandSelector from "./components/StandSelector";
import useGarageStore from "@/store/useGarbage.store";
import { Link } from "react-router-dom";
import { Icon } from "@/components/icons/Icon";
import { BASE_URL } from "@/constants/constants";
import { literals } from "@/constants/literals";
import useReceptionDataStore from "@/store/useReceptionData.store";
import useExitsDataStore from "@/store/useExitsData.store";

export const Capture = () => {
  const { clearGroupData } = useGarageStore();
  const { clearReceptionGroupData } = useReceptionDataStore();
  const { clearExitsGroupData } = useExitsDataStore();

  useEffect(() => {
    clearGroupData();
    clearReceptionGroupData();
    clearExitsGroupData();
  }, [clearGroupData, clearReceptionGroupData, clearExitsGroupData]);

  return (
    <div className="absolute top-12 min-h-fulldpx w-full bg-ib-pt-color-white">
      <div className="h-10 w-full flex flex-row items-center py-1 px-14 bg-ib-pt-color-neutral-100 border-b border-b-ib-pt-color-gray-100">
        <Link
          to={BASE_URL}
          className="self-center ib-pt-main text-ib-pt-color-red-500 flex flex-row justify-start items-center"
        >
          <Icon name="backArrow" className="size-4 mr-4" />
          <span>{literals.backToHome}</span>
        </Link>
      </div>
      <div className="flex flex-col md:flex-row gap-y-2 md:gap-x-2 md:h-[280px] px-3 md:px-14 py-6 max-md:min-h-[calc(100vh-90px)] w-full">
        <StandSelector stand="reception" />
        <StandSelector stand="garage" />
        <StandSelector stand="exits" />
      </div>
    </div>
  );
};
